import React, { Suspense } from 'react';

import LoadingComponent from '../components/Loading';

import { ErrorBoundary } from './ErrorBoundary';

function universal(load, page) {
  const Cmp = React.lazy(load);
  return (props) => (
    <ErrorBoundary page={page}>
      <Suspense fallback={<LoadingComponent />}>
        <Cmp {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}

export const CompletePayoutRequest = universal(
  () => import('./CompletePayoutRequest'),
  'CompletePayoutRequest'
);
export const DeleteAccount = universal(
  () => import('./DeleteAccount'),
  'DeleteAccount'
);
export const ForgotPassword = universal(
  () => import('./ForgotPassword'),
  'ForgotPassword'
);
export const FullSignup = universal(() => import('./FullSignup'), 'FullSignup');
export const InviteAccountabilityLanding = universal(
  () => import('./InviteAccountabilityLanding'),
  'InviteAccountabilityLanding'
);
export const InviteLanding = universal(
  () => import('./InviteLanding'),
  'InviteLanding'
);
export const Loading = universal(() => import('./Loading'), 'Loading');
export const Login = universal(() => import('./Login'), 'Login');
export const MembershipSignup = universal(
  () => import('./MembershipSignup'),
  'MembershipSignup'
);
export const ReferralSignup = universal(
  () => import('./ReferralSignup'),
  'ReferralSignup'
);
export const ResetPassword = universal(
  () => import('./ResetPassword'),
  'ResetPassword'
);
export const RoutinesGameLanding = universal(
  () => import('./RoutinesGameLanding'),
  'RoutinesGameLanding'
);
export const Signup = universal(() => import('./Signup'), 'Signup');
export const StartGameOrder = universal(
  () => import('./StartGameOrder'),
  'StartGameOrder'
);
export const StartGameBetOrder = universal(
  () => import('./StartGameBetOrder'),
  'StartGameBetOrder'
);
export const StartMembershipOrder = universal(
  () => import('./StartMembershipOrder'),
  'StartMembershipOrder'
);
export const StartOrder = universal(() => import('./StartOrder'), 'StartOrder');
export const OptionalBet = universal(
  () => import('./OptionalBet'),
  'OptionalBet'
);
